import { createReducer, on } from '@ngrx/store';
import { Brand } from '../domain/brand';
import { Feed } from '../domain/feed';
import { Rating } from '../domain/rating';
import * as Actions from './content-group.actions';

export const featureKey = 'cxbContentGroup';

export interface FeatureState {
  feeds: Feed[];
  brands: Brand[];
  ratings: Rating[];
  loading: boolean;
  isCastLoading: boolean;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  feeds: [],
  brands: [],
  ratings: [],
  loading: false,
  isCastLoading: false,
};

export const reducer = createReducer(
  initialState,
  on(Actions.fetchFeed, (state): FeatureState => ({ ...state, feeds: [], loading: true })),
  on(Actions.fetchFeedSuccess, (state, action): FeatureState => ({ ...state, loading: false, feeds: action.feeds })),
  on(Actions.fetchFeedFail, (state): FeatureState => ({ ...state, feeds: [], loading: false })),

  on(Actions.fetchBrands, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.fetchBrandsSuccess, (state, action): FeatureState => ({ ...state, loading: false, brands: action.brands })),
  on(Actions.fetchBrandsFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.fetchRatings, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.fetchRatingsSuccess, (state, action): FeatureState => ({ ...state, loading: false, ratings: action.ratings })),
  on(Actions.fetchRatingsFail, (state): FeatureState => ({ ...state, loading: false }))
);
